import { render } from "./ProjectHoursComponent.vue?vue&type=template&id=43cade00"
import script from "./ProjectHoursComponent.vue?vue&type=script&lang=js"
export * from "./ProjectHoursComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__